import { render } from "./AutomationWizardOverviewBenefits.vue?vue&type=template&id=1429095e"
import script from "./AutomationWizardOverviewBenefits.vue?vue&type=script&lang=js"
export * from "./AutomationWizardOverviewBenefits.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__